// Cliente HTTP para endpoints de Bairros + Pedido Minimo.

import axios from "axios";

const API = "/api";

const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

export const bairrosApi = {
  // CRUD
  listar: () => axios.get(`${API}/bairros`, authHeader()),
  criar: (data) => axios.post(`${API}/bairros`, data, authHeader()),
  atualizar: (id, data) => axios.put(`${API}/bairros/${id}`, data, authHeader()),
  deletar: (id) => axios.delete(`${API}/bairros/${id}`, authHeader()),

  // Bulk operations
  setarCepEmTodos: (cep) =>
    axios.put(`${API}/bairros/cep/all?cep=${encodeURIComponent(cep)}`, {}, authHeader()),
  setarValorEmTodos: (valor) =>
    axios.put(`${API}/bairros/valor/all?valor_entrega=${valor}`, {}, authHeader()),
  ajustarValorEmTodos: (delta) =>
    axios.put(`${API}/bairros/valor/adjust?delta=${delta}`, {}, authHeader()),

  // Utilização (% de pedidos por bairro, últimos 90 dias)
  getUsage: () =>
    axios
      .get(`${API}/bairros/usage`, authHeader())
      .catch(() => ({ data: { window_days: 90, total_pedidos: 0, por_bairro: {} } })),

  // Pedido minimo (config global)
  getPedidoMinimo: () =>
    axios
      .get(`${API}/delivery/min-order`, authHeader())
      .catch(() => ({ data: { pedido_minimo: 0 } })),
  setPedidoMinimo: (pedido_minimo) =>
    axios.post(`${API}/delivery/min-order`, { pedido_minimo }, authHeader()),
};
